import { render } from "./HospitalInso.vue?vue&type=template&id=66fb2824&scoped=true"
import script from "./HospitalInso.vue?vue&type=script&lang=js"
export * from "./HospitalInso.vue?vue&type=script&lang=js"

import "./HospitalInso.vue?vue&type=style&index=0&id=66fb2824&scoped=true&lang=css"
import "./HospitalInso.vue?vue&type=style&index=1&id=66fb2824&lang=css"
import "../../style/HospitalInso.css?vue&type=style&index=2&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fb2824"]])

export default __exports__